const state = () => ({
  selectedMemberIds: [],
  academicRecordsGradeCode: null,
  filterParams: {},
  returnMemberId: null,
})

const mutations = {
  setSelectedMemberIds(state, ids) {
    state.selectedMemberIds = ids
  },
  setAcademicRecordsGradeCode(state, gradeCode) {
    state.academicRecordsGradeCode = gradeCode
  },
  setFilterParams(state, params) {
    state.filterParams = params
  },
  setReturnMemberId(state, memberId) {
    state.returnMemberId = memberId
  },
  clearReturnMemberId(state) {
    state.returnMemberId = null
  },
}

export default {
  namespaced: true,
  state,
  getters: {},
  mutations,
}
